import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './core/app/app.component';
import { CoreModule } from './core/core.module';
import { UserManagerModule } from './user-manager/user-manager.module';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [
    ],
    imports: [
        BrowserModule,
        CommonModule,
        CoreModule,
        UserManagerModule,
        NgbModule
    ],
    providers: [
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
